import React from "react";
import { Table, TableContainer, Paper } from "@mui/material";
import { useForm } from "react-hook-form";
import ButtonWrapper from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/components/Button";
import { yesOrNo } from "../../citizen/TCPForms/data";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";

const ConversionChecklist = ({ formData, handleTabChange, isEmployee, handleChecklistNoWorkflow }) => {
  const { control, handleSubmit } = useForm();
  console.log("fromconversionchecklist", isEmployee);
  const tenantId = Digit.ULBService.getStateId() || "up";

  const { data: { BPA: { LandUseConversionChecklist } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [
    "LandUseConversionChecklist",
  ]);
  console.log("LandUseConversionChecklist", LandUseConversionChecklist, tenantId);
  // 🔹 Temporary hardcoded data (replace with MDMS later)
  // const ConversionChecklistData = [
  //   {
  //     code: "applicationReceivedInPrescribedFormat",
  //     question: "Has the application been received in the prescribed format?",
  //   },
  //   {
  //     code: "khatauniOwnershipDocument",
  //     question: "Has a certified copy of Khatauni or ownership document been submitted?",
  //   },
  //   {
  //     code: "landDisputeStatus",
  //     question: "Is there any existing land dispute related to the proposed land?",
  //   },
  //   {
  //     code: "masterPlanConformity",
  //     question: "Is the proposal in conformity with the Master Plan?",
  //   },
  //   {
  //     code: "environmentalImpactAssessment",
  //     question: "Has an environmental impact assessment been conducted?",
  //   },
  // ];

  const onSubmit = (data) => {
    console.log("conversionChecklistfromcomponenet", data);

    handleChecklistNoWorkflow(data?.conversionChecklist);
    // handleTabChange(3, data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TableContainer component={Paper} className="table-container">
        <Table stickyHeader className="application-table">
          <thead>
            <tr style={{ background: "#f0f0f0" }}>
              <th style={{ width: "70%" }}>Checklist</th>
              <th style={{ width: "10%", textAlign: "center" }}>Compliant</th>
              <th style={{ width: "20%", textAlign: "center" }}>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {LandUseConversionChecklist?.length > 0 &&
              LandUseConversionChecklist?.map((item) => (
                <tr key={item.code}>
                  <td>
                    {item.question}
                    <span style={{ color: "red", marginLeft: "3px", fontWeight: "bold" }}>*</span>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {
                      <InputWrapper
                        control={control}
                        hasLabel={false}
                        name={`conversionChecklist.${item.code}.compliance`}
                        defaultValue={formData?.conversionChecklist?.[item.code]}
                        type="radioButton"
                        data={yesOrNo}
                        mandatory
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        }}
                      />
                    }
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {
                      <InputWrapper
                        control={control}
                        hasLabel={false}
                        name={`conversionChecklist.${item.code}.remarks`}
                        defaultValue={formData?.conversionChecklist?.[item.code]}
                        type="textInput"
                        // data={yesOrNo}
                        mandatory
                        validation={{
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        }}
                      />
                    }
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </TableContainer>

      {isEmployee && (
        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      )}
    </form>
  );
};

export default ConversionChecklist;
